export default __webpack_public_path__ + "static/assets/im_reserve_feedpoint.e45937eec072c93598018af76bf3b2bd.png";